import { defaultColumns, defaultSort } from '../../components/data/partners/forms/contactPeople/columns';

export default {

  state: {
    tableConfig: null,
    loading: false,
  },

  getters: {
    tableConfig: state => state.tableConfig,
    loading: state => state.loading,
  },

  mutations: {
    setTableConfig(state, config) {
      state.tableConfig = config;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
  },

  actions: {
    async fetchTableConfig({ commit }) {
      commit('setLoading', true);
      try {
        const setting = await axios.get('api/table-settings/contact-person-list');
        if (setting.id) {
          const tableConfig = {
            id: setting.id,
            type: 'contact-person-list',
            columns: JSON.parse(setting.config).columns,
            sort: JSON.parse(setting.config).sort,
          };
          commit('setTableConfig', tableConfig);
        } else {
          const tableConfig = {
            type: 'contact-person-list',
            columns: defaultColumns,
            sort: defaultSort,
          };
          commit('setTableConfig', tableConfig);
        }
      } catch (e) {
      }
      commit('setLoading', false);
    },
  }

}
